import React, { useContext, useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import supabase from "../config/supabaseClient";
import estilo from "../styles/Anime.module.css";
import Comentarios from "../components/Comentarios";
import { DataContext } from "../context/DataContext";
import MetaDecorator from "../utils/MetaDecorator";
import CargaAnime from "../components/other/CargaAnime";

function Anime() {
  let navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const { id } = useParams();

  const [anime, setAnime] = useState(null);
  const [carga, setCarga] = useState(true);

  useEffect(() => {
    const fetchAnime = async () => {
      const { data, error } = await supabase
        .from("anime")
        .select()
        .eq("uid", id)
        .single();

      if (error) {
        setAnime(null);
        navigate("/");
      }
      if (data) {
        setAnime(data);
        // console.log(data);
      }
      setCarga(false);
    };

    fetchAnime();
  }, [id, navigate]);

  const { setData, setCambio } = useContext(DataContext);

  return (
    <div className={estilo.anime}>
      {anime && (
        <MetaDecorator
          titulo={"Ver " + anime.nombre + " en linea Gratis | yTAnimeTV"}
          subtitulo={anime.nombre + " | yTAnimeTV"}
          descripcion={anime.sinopsis}
          keywords={
            anime.nombre +
            " - " +
            anime.generos.map((e) => e.genero).join(", ") +
            " numero de capítulos: " +
            anime.cantidad_capitulos
          }
          url={"https://ytanimetv.com/" + anime.uid}
          canonical={"https://ytanimetv.com/" + anime.uid}
        />
      )}

      {carga ? (
        <CargaAnime></CargaAnime>
      ) : (
        <>
          {anime && (
            <div className={estilo.informacion}>
              <div className={estilo.informacion_anime}>
                <div className={estilo.portada}>
                  <img src={anime.portada} alt={anime.nombre} />
                  <div className={estilo.estado}>
                    {anime.estado ? <p>En Emisión</p> : <p>Finalizado</p>}
                  </div>
                </div>

                <div className={estilo.datos}>
                  <h3>{anime.nombre}</h3>
                  <p className={estilo.tipo}>
                    <b>Tipo: </b>
                    {anime.tipo}
                  </p>

                  {anime.precuela === null ? null : (
                    <Link to={"/" + anime.precuela.replaceAll(" ", "-")}>
                      <p className={estilo.links}>
                        <b>Precuela: </b>
                        {anime.precuela}
                      </p>
                    </Link>
                  )}

                  {anime.secuela === null ? null : (
                    <Link to={"/" + anime.secuela.replaceAll(" ", "-")}>
                      <p className={estilo.links}>
                        <b>Secuela: </b>
                        {anime.secuela}
                      </p>
                    </Link>
                  )}

                  {anime.adicional === null ? null : (
                    <Link to={"/" + anime.adicional.replaceAll(" ", "-")}>
                      <p className={estilo.links}>
                        <b>Adicional: </b>
                        {anime.adicional}
                      </p>
                    </Link>
                  )}

                  <div className={estilo.generos}>
                    {anime.generos.map((e, i) => (
                      <Link
                        to={"/animes"}
                        key={i}
                        onClick={() => setData(e.genero) || setCambio(false)}
                      >
                        <p>{e.genero}</p>
                      </Link>
                    ))}
                  </div>
                  <div className={estilo.sinopsis}>
                    <p>{anime.sinopsis}</p>
                  </div>
                </div>
              </div>

              <div className={estilo.capitulos}>
                {anime.capitulos
                  .slice(0)
                  .reverse()
                  .map((e, i) => (
                    <Link to={"/" + e.id + "/" + e.numero} key={i}>
                      <div className={estilo.cap}>
                        <div className={estilo.cap_portada}>
                          <img src={e.portada} alt={e.id} />
                        </div>

                        <div className={estilo.cap_numero}>
                          <p>
                            <b>Cap</b>: {e.numero}
                          </p>
                        </div>
                      </div>
                    </Link>
                  ))}
              </div>

              <Comentarios></Comentarios>
            </div>
          )}
        </>
      )}
    </div>
  );
}

export default Anime;
